import { add } from 'date-fns'
import { Consulta } from '../../models/Consulta'
import { store } from '../../store'
import { atualizaMedico } from '../../store/medico/actions'
import { atualizaEspecialidade } from '../../store/especialidade/actions'
import { atualizaLocal } from '../../store/local/actions'
import { atualizaPaciente } from '../../store/paciente/actions'
import { atualizaPagamento } from '../../store/pagamento/actions'
import { atualizaHorario } from '../../store/horario/actions'
import { atualizaEscolha } from '../../store/consulta/actions'
import ArmazenamentoHelper from './armazenamentoHelper'

/** Preenchimento de Consulta */
class PreenchimentoConsultaHelper {
  /**
   * Realiza preenchimento
   * dos dados no local store
   */
  public static realizaPreenchimento(): void {
    const { consulta } = store.getState()
    const dadosASeremArmazenados: Consulta = {
      ...consulta,
      horario: undefined
    }

    const dadosPreenchidosEmString = JSON.stringify(dadosASeremArmazenados)
    const dadosPreenchidosEmStringBase64 = btoa(dadosPreenchidosEmString)
    ArmazenamentoHelper.armazenaNoLocalStorage(
      'fluxo_preenchido',
      dadosPreenchidosEmStringBase64,
      add(new Date(), { minutes: 10 })
    )
  }

  /**
   * Carrega os dados do preenchimento
   * no Store de consultas
   *
   * @returns {Promise<void>}
   */
  public static carregaDados(): Promise<void> {
    return new Promise(resolve => {
      const { dispatch } = store

      const dadosPreenchidosEmStringBase64 = ArmazenamentoHelper.recuperaDoLocalStorage(
        'fluxo_preenchido'
      )
      if (dadosPreenchidosEmStringBase64) {
        const dadosPreenchidos: Consulta = JSON.parse(
          atob(dadosPreenchidosEmStringBase64)
        )

        dispatch(atualizaMedico(dadosPreenchidos.medico))
        dispatch(atualizaEspecialidade(dadosPreenchidos.especialidade))
        dispatch(
          atualizaEscolha({
            escolhaPorMedico: dadosPreenchidos.escolhaPorMedico,
            escolhaPorEspecialidade: dadosPreenchidos.escolhaPorEspecialidade
          })
        )
        dispatch(atualizaLocal(dadosPreenchidos.local))
        dispatch(atualizaPaciente(dadosPreenchidos.paciente))
        dispatch(atualizaPagamento(dadosPreenchidos.pagamento))
        dispatch(atualizaHorario(dadosPreenchidos.horario))
      }

      setTimeout(() => resolve(), 100)
    })
  }

  /**
   * Verifica se existem
   * dados preenchidos
   *
   * @returns {boolean}
   */
  public static existemDados(): boolean {
    return ArmazenamentoHelper.recuperaDoLocalStorage('fluxo_preenchido') !== ''
  }

  /**
   * Remove os dados
   * preenchidos do LocalStore
   *
   * @returns {void}
   */
  public static removeDados(): void {
    ArmazenamentoHelper.removeDoLocalStorage('fluxo_preenchido')
  }
}

export default PreenchimentoConsultaHelper
